import classNames from 'classnames';
import { Body } from '@components/text';
import './TooltipContent.scss';

export interface TooltipContentProps {
  /** The text content of the tooltip. */
  children: string;
  /** The size of the content text. Default large */
  size?: 'small' | 'large';
  /** Color theme of the content. Default primary */
  variant?: 'primary' | 'secondary';
}

/**
 * TooltipContent is a styled div to be used as the popover content for a Tooltip
 * @param children - The content of the tooltip.
 * @param size - The size of the content text. Default large
 * @param variant - Color theme of the content. Default primary
 */
export const TooltipContent: React.FC<TooltipContentProps> = ({
  children,
  size = 'large',
  variant = 'primary',
  ...rest
}) => (
  <div className={classNames('vds-tooltip-content', `vds-tooltip-content--${variant}`)} {...rest}>
    <Body className="vds-tooltip-content__body" variant="body-02" size={size} weight="semibold">
      {children}
    </Body>
  </div>
);
